import { Fragment } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Fade, Tooltip } from '@material-ui/core';
import { grayColor, whiteColor } from 'assets/jss/material-dashboard-pro-react';

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    fontSize: '12px',
    backgroundColor: grayColor[18],
    color: whiteColor,
  },
  colorBar: {
    width: '3px',
    marginRight: '15px',
    borderRadius: '10px',
  },
  contentColumn: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '10px',
    fontWeight: '400',
  },
  title: {
    fontSize: '14px',
  },
  lastRow: {
    marginBottom: '3px',
  },
  highlight: {
    display: 'inline-block',
    marginRight: '6px',
    padding: '3px',
    textAlign: 'center',
    backgroundColor: `${whiteColor}1A`,
    borderRadius: '6px',
  },
  hr: {
    height: '1px',
    margin: '0',
    backgroundColor: grayColor[1],
    border: 'none',
  },
  childrenWrapper: {
    display: 'inline-block',
  },
});

const MetricTooltip = ({ children, title, color, content, isDisabled }) => {
  const classes = useStyles();

  return (
    <Tooltip
      interactive={true}
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 300 }}
      placement="top"
      {...(isDisabled && {
        disableHoverListener: true,
        disableFocusListener: true,
        disableTouchListener: true,
      })}
      title={
        <div className={classes.wrapper}>
          <div
            className={classes.colorBar}
            style={{ backgroundColor: color }}
          />
          <div className={classes.contentColumn}>
            <div className={classes.title}>{title}</div>
            {content.map(
              (
                { hasLineBefore = false, highlightedText = '', text = '' },
                index
              ) => (
                <Fragment key={`${hasLineBefore}-${text}-${highlightedText}`}>
                  {hasLineBefore && <hr className={classes.hr} />}
                  <div
                    className={
                      index === content.length - 1 ? classes.lastRow : undefined
                    }
                    key={`${text}-${highlightedText}`}
                  >
                    {highlightedText && (
                      <span className={classes.highlight}>
                        {highlightedText}
                      </span>
                    )}
                    {text}
                  </div>
                </Fragment>
              )
            )}
          </div>
        </div>
      }
    >
      <div className={classes.childrenWrapper}>{children}</div>
    </Tooltip>
  );
};

export default MetricTooltip;
